import React from 'react';
import { Envelope, Whatsapp } from 'react-bootstrap-icons';
import './style.scss';

export default function ContactDetails() {
  return (
    <div className="contact-details text-white p-4">
      <h5 style={{ fontSize: '16px' }} className="text-primary mb-3">
        Having trouble? Contact Us:
      </h5>
      <div className="details">
        <a
          href="mailto:info@accurateliensearch.net?subject=Questions%20on%20the%20Order%20Form"
          className="d-flex align-items-center mb-1"
        >
          <Envelope size={16} />
          <p className="mb-0 ml-2 text-lg">Email Us</p>
        </a>
        <a
          href="https://wa.me/+13054033405"
          target="_blank"
          rel="noopener noreferrer"
          className="d-flex align-items-center"
        >
          <Whatsapp size={16} />
          <p className="mb-0 ml-2">WhatsApp</p>
        </a>
      </div>
    </div>
  );
}
